/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import examples from './examples';

export default {
  doc: {
    description: `Mineral UI provides several different bundled themes.  Choose the one that best suits your style.  Please see the [theming guide](/theming) for more information.`
  },
  examples,
  hidePropDoc: true,
  slug: 'themes',
  title: 'Themes'
};



// WEBPACK FOOTER //
// ./src/website/app/demos/themes/index.js